import { get } from 'lodash'
import ContentfulInformationPages from 'models/data/contentful/ContentfulInformationPages'
import ContentfulToApiInformationPage from '../mappings/ContentfulToApiInformationPage';

class ApiInformationPage {
	static default = {
		title: "",
		bodyHtml: ""
	};

	static pages = {
		PRIVACY_POLICY: "privacy",
		TERMS_OF_USE: "terms",
		COPYRIGHT_DISPUTE_POLICY: "copyright",
		PITCH_US: "pitch",
		ABOUT_US: "about",
		FAQ: "faq",
		WHY_SUBSCRIBE: "whysubscribe",
		CONTACT: "contact",
		ETHICS_POLICY: "ethics"
	};

	static titles = {
		[ApiInformationPage.pages.PRIVACY_POLICY]: "Privacy Policy",
		[ApiInformationPage.pages.TERMS_OF_USE]: "Terms of Use",
		[ApiInformationPage.pages.COPYRIGHT_DISPUTE_POLICY]: "Copyright Dispute Policy",
		[ApiInformationPage.pages.PITCH_US]: "Pitch Us",
		[ApiInformationPage.pages.ABOUT_US]: "About Us",
		[ApiInformationPage.pages.FAQ]: "FAQ",
		[ApiInformationPage.pages.WHY_SUBSCRIBE]: "Why Subscribe",
		[ApiInformationPage.pages.CONTACT]: "Contact",
		[ApiInformationPage.pages.ETHICS_POLICY]: "Ethics Policy"
	};

	static async fetch(page) {
		const pageTitle = ApiInformationPage.titles[page];
        const contentfulInformationPages = await ContentfulInformationPages.fetch();
        const informationPages = contentfulInformationPages.map(page => ContentfulToApiInformationPage.map(page))
        const [informationPage] = informationPages.filter(page => ApiInformationPage.title(page) === pageTitle)
        return informationPage ? informationPage : ApiInformationPage.default
	}

	static title = apiInformationPage =>
		get(apiInformationPage, "title", ApiInformationPage.default.title);

	static bodyHtml = apiInformationPage =>
		get(apiInformationPage, "bodyHtml", ApiInformationPage.default.bodyHtml);
}

export default ApiInformationPage
